import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import PalletStockForm from './PalletStockForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import ReactPlaceholder from 'react-placeholder/lib';

const PalletStock = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})

    const [ready, setReady] = useState(false)

    const [rowsBranchOffice, setRowsBranchOffice] = useState([])
    const [dataFilter, setDataFilter] = useState({
        p_id_customers: '',
        p_id_sponsor: '',
        p_id_upline: '',
        p_name_customers: '',
        p_last_name_customers: '',
        p_curp_customers: '',
        p_id_pallet_stock: ''
    })

    const branchOffice = useMemo(() => {
        if (!dataFilter.p_id_pallet_stock) {
            return {
                label: 'Todas',
                value: ''
            }
        }

        let finded = rowsBranchOffice.find(t => parseInt(dataFilter.p_id_pallet_stock) === parseInt(t.id_pallet_stock))

        if (!finded) {
            return
        }

        return {
            label: `${finded.key_pallet_stock} - ${finded.name_pallet_stock}`,
            value: finded.id_pallet_stock
        }
    }, [dataFilter.p_id_pallet_stock, rowsBranchOffice])

    useEffect(() => {
        Controllers.pallet_stock.get_pallet_stock().then(res => {
            setRowsBranchOffice([{ name_pallet_stock: 'Todas', id_pallet_stock: '' }, ...res.data])
            setReady(true)
        })
    }, [])

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.pallet_stock.get_pallet_stock().then(res => {
                setRows(res.data)
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                    setReload(false)
                })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.pallet_stock.pallet_stock_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleGet = e => {
        let $this = e.currentTarget

        if (!$this.dataset?.idPalletStock) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let buttonHTML = $this.innerHTML;
        $this.innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>'
        let { idPalletStock, picking = 0, history = 0, historyFull = 0 } = $this.dataset

        Controllers.pallet_stock.get_pallet_stock_id({ p_id_pallet_stock: idPalletStock }).then(res => {
            setModalTitle(`Modificar ${nameSingle} #${idPalletStock}`)
            setDataUpdated({
                data: res.data, picking, history, historyFull
            })
            setModalShow(true);
        }).catch(req => {
            Helpers.promise.catch({ req, toast })
            setReload(true)
        })
            .finally(() => $this.innerHTML = buttonHTML)
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.pallet_stock.pallet_stock_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true)
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    /* const handleShowModalDelete = e => {
        let { idPalletStock, namePalletStock } = e.currentTarget.dataset
        setDataDeleted({
            p_id_pallet_stock: idPalletStock,
            p_name_pallet_stock: namePalletStock
        })
        setShowConfirmDelete(true)
    }

    const handleShowModalComponent = e => {
        let { idPalletStock } = e.currentTarget.dataset
        setModalTitleComponent('Agregar Componentes a PalletStocko #' + idPalletStock)
        setDataComponent({
            idPalletStock
        })
        setModalShowComponent(true)
    }

    const handleShowModalPrice = e => {
        let { idPalletStock } = e.currentTarget.dataset
        setModalTitlePrice('Listado de Precios del PalletStocko #' + idPalletStock)
        setDataPrice({
            idPalletStock
        })
        setModalShowPrice(true)
    }

    const handleHideModalComponent = _ => {
        setModalShowComponent(false)
    }

    const handleHideModalPrice = _ => {
        setModalShowPrice(false)
    } */

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_pallet_stock', text: 'ID' },
                { name: 'name_pallet_stock', text: 'Nombre' },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            <Button variant="info" className="mr-1" size="xs" data-id-pallet-stock={u.id_pallet_stock} onClick={handleGet}>
                                <i className="fa fa-edit"></i>
                            </Button>
                            <Button variant="dark" className="mr-1" size="xs" data-picking={1} data-id-pallet-stock={u.id_pallet_stock} data-add-products={1} onClick={handleGet}>
                                <i className="far fa-hand-paper"></i>
                            </Button>
                            <Button variant="primary" className="mr-1" size="xs" data-history={1} data-id-pallet-stock={u.id_pallet_stock} onClick={handleGet}>
                                <i className="fas fa-clipboard-list"></i>
                            </Button>
                            <Button variant="success" className="mr-1" size="xs" data-id-pallet-stock={u.id_pallet_stock} data-history-full={1} onClick={handleGet}>
                                <i className="fas fa-file-contract"></i>
                            </Button>
                            {/* <Button variant="danger" className="mr-1" size="xs" data-id-pallet-stock={u.id_pallet_stock} data-name-pallet_stock={u.name_pallet_stock} onClick={handleShowModalDelete}>
                                <i className="fa fa-trash"></i>
                            </Button> */}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing, handleGet])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                <Button size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> Registrar {nameSingle}
                </Button>
            </Card.Header>
            <Card.Body>
                <ReactPlaceholder ready={ready} rows={15} showLoadingAnimation>
                    {dtRows}
                </ReactPlaceholder>
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size="xl">
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PalletStockForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_pallet_stock} - {dataDeleted.p_name_pallet_stock}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
    </>
}

export default PalletStock